export default "__VITE_ASSET__de58b096__"